import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "START_BUTTONS", {
  WITH_IMAGES: "With Images",
  WITHOUT_IMAGES: "Without Images",
});
